import { Badge } from '@commenda/kakashi';

import { CommendaAgentMentionHelper } from '../commenda-agent-mention-helper';

const CommendaAgentMentionPill = () => (
  <Badge
    variant="blue"
    size="sm"
    className={CommendaAgentMentionHelper.PILL_CLASS_NAME}
  >
    @{CommendaAgentMentionHelper.NAME}
  </Badge>
);

export default CommendaAgentMentionPill;
